import { generateUUID, isContentfulString } from '@philips-internal/oswald-ui-utils';
import { SessionStorageService } from '../session-storage-service/index.js';
import { OPENID_CONNECT_STATE } from './openid-connect-service-constants.js';
function createOpenIDConnectService() {
    const clearState = () => {
        SessionStorageService.removeItem(OPENID_CONNECT_STATE);
    };
    const getState = () => {
        return SessionStorageService.getItem(OPENID_CONNECT_STATE);
    };
    const setState = (redirectPath) => {
        const state = {
            id: generateUUID(),
            redirectPath,
        };
        SessionStorageService.setItem(OPENID_CONNECT_STATE, state);
        return state;
    };
    const validateState = (state) => {
        const currentState = getState();
        return Boolean(state && isContentfulString(state) && currentState?.id === state);
    };
    return {
        clearState,
        getState,
        setState,
        validateState,
    };
}
const OpenIDConnectService = createOpenIDConnectService();
export { OpenIDConnectService, };
//# sourceMappingURL=openid-connect-service.js.map